import { useMfa } from '@iheartjane/menu';
import { Box, Loading } from '@iheartjane/reefer';
import type { AerosyncWidget } from 'aerosync-web-sdk';
import { useCallback, useEffect, useState } from 'react';
import type { MutableRefObject } from 'react';

import { useJaneUser } from '@jane/shared/data-access';

import { MultifactorAuthentication } from '../../MultifactorAuthentication/MultifactorAuthentication';

interface AeropayScreenProps {
  isLinkingBankAccount: boolean;
  isLoadingWidget: boolean;
  widgetRef: MutableRefObject<AerosyncWidget | null>;
}

const WIDGET_CONTAINER_ID = 'aerosync-widget';

export const AeropayScreen = ({
  isLinkingBankAccount,
  isLoadingWidget,
  widgetRef,
}: AeropayScreenProps) => {
  const { requiresMfa } = useMfa();
  const [userVerified, setUserVerified] = useState(false);
  const { data: janeUser } = useJaneUser();
  const phoneNumber = janeUser?.user?.phone;

  const handleVerifySuccess = useCallback(() => {
    setUserVerified(true);
    widgetRef.current && widgetRef.current.launch();
  }, [widgetRef]);

  useEffect(() => {
    if (!isLoadingWidget && !requiresMfa()) {
      handleVerifySuccess();
    }
  }, [isLoadingWidget]);

  return (
    <>
      {isLinkingBankAccount && <Loading />}
      <Box width="100%">
        {!userVerified && requiresMfa() && !isLinkingBankAccount && (
          <MultifactorAuthentication
            onSuccess={handleVerifySuccess}
            phoneNumber={phoneNumber || ''}
          />
        )}

        <div id={WIDGET_CONTAINER_ID}></div>
      </Box>
    </>
  );
};
